import { render, staticRenderFns } from "./inventoryList.vue?vue&type=template&id=4c8137a4&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"
import style0 from "./inventoryList.vue?vue&type=style&index=0&id=4c8137a4&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8137a4",
  null
  
)

export default component.exports